var _g, _g2, _g3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenceTypeGrs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6676_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72308 7.39955V6.26367L2.00397 6.26367V7.39955L7.72308 7.39955Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71912 5.25599V4.12012L2.00001 4.12012V5.25599L7.71912 5.25599Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71912 3.13588V2L2.00001 2V3.13588L7.71912 3.13588Z",
    fill: "#3F4451"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6676_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4206 4.51273C13.1145 4.51273 13.677 3.95024 13.677 3.25637C13.677 2.56249 13.1145 2 12.4206 2C11.7267 2 11.1642 2.56249 11.1642 3.25637C11.1642 3.95024 11.7267 4.51273 12.4206 4.51273Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48299 7.46C10.1769 7.46 10.7394 6.8975 10.7394 6.20363C10.7394 5.50976 10.1769 4.94727 9.48299 4.94727C8.78912 4.94727 8.22662 5.50976 8.22662 6.20363C8.22662 6.8975 8.78912 7.46 9.48299 7.46Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4206 7.46C13.1145 7.46 13.677 6.8975 13.677 6.20363C13.677 5.50976 13.1145 4.94727 12.4206 4.94727C11.7267 4.94727 11.1642 5.50976 11.1642 6.20363C11.1642 6.8975 11.7267 7.46 12.4206 7.46Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47304 4.51273C10.1669 4.51273 10.7294 3.95024 10.7294 3.25637C10.7294 2.56249 10.1669 2 9.47304 2C8.77917 2 8.21667 2.56249 8.21667 3.25637C8.21667 3.95024 8.77917 4.51273 9.47304 4.51273Z",
    fill: "#3F4451"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6676_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3172 12.4241L9.45094 13.151L9.15854 11.9231L8.86628 10.695L10.0248 11.1962L11.1834 11.6974L10.3172 12.4241Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9495 12.4241L12.0832 13.151L11.7908 11.9231L11.4985 10.695L12.6571 11.1962L13.8156 11.6974L12.9495 12.4241Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3172 9.79033L9.45106 10.5171L9.15878 9.28928L8.86639 8.06131L10.0249 8.5625L11.1835 9.06343L10.3172 9.79033Z",
    fill: "#3F4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9495 9.79032L12.0833 10.5171L11.791 9.28928L11.4986 8.06131L12.6573 8.56238L13.8158 9.06343L12.9495 9.79032Z",
    fill: "#3F4451"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1207 10.4433V9.53259C6.32008 9.52957 5.67024 8.87972 5.66722 8.0791H4.75653C4.75955 9.38332 5.81649 10.4403 7.1207 10.4433Z",
    fill: "#3F4451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12068 12.9994V12.1234C6.04112 12.1234 5.02639 11.7027 4.26196 10.9398C3.49903 10.1768 3.07836 9.16061 3.07836 8.08105H2.20386C2.20386 10.7965 4.40519 12.9994 7.12218 12.9994H7.12068Z",
    fill: "#3F4451"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6676_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.72308,
    height: 5.72308,
    fill: "white",
    transform: "translate(2 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6676_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.72308,
    height: 5.72308,
    fill: "white",
    transform: "translate(7.95386 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6676_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.36923,
    height: 6.36923,
    fill: "white",
    transform: "translate(7.6308 7.58496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceTypeGrs);
export default __webpack_public_path__ + "static/media/licence_type_grs.86608e63b0efbdf5e16ca1dbd98e1613.svg";
export { ForwardRef as ReactComponent };